import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { Link } from 'react-router-dom';
import { CopyLinkOpenBankingEmailButton } from '../CopyLinkOpenBankingEmailButton/CopyLinkOpenBankingEmailButton';
import styles from './LinkOpenBanking.module.css';

type TProps = {
  email: string;
  firstName: string;
};

export const LinkOpenBanking = ({ email, firstName }: TProps) => {
  const { introducer } = useIntroducerData();

  if (!introducer) {
    return null;
  }

  return (
    <div className={styles.linkOpenBanking}>
      <h3>Link applicant's account(s) via Open Banking</h3>
      <div className={styles.info}>
        <div className={styles.details}>
          <ul>
            <li>We’ll write an email for you to send to your customer</li>
            <li>
              They’ll be able to link their bank account(s) in their iwoca
              account via{' '}
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://truelayer.com/reports/open-banking-guide/what-is-open-banking/"
                className={styles.openBankingUrl}
              >
                Open Banking
              </Link>
            </li>
            <li>
              iwoca will not contact them directly, except to send them a login
              link to their account
            </li>
          </ul>
          <p>
            Applicants that link Open Banking receive a decision{' '}
            <b>2x faster</b> than those who share PDF bank statements on
            average.
          </p>
        </div>
        <CopyLinkOpenBankingEmailButton
          customerFirstName={firstName}
          customerEmail={email}
          introducerFirstName={introducer.first_name}
        />
      </div>
    </div>
  );
};
